import { FileArrowDown } from '@phosphor-icons/react/dist/ssr/FileArrowDown'

type Props = {
  title: string
  description?: string
  href: string
  fileLabel?: string
}

export const FileDownloadCard = ({ title, description, href, fileLabel }: Props) => (
  <div className="my-8 flex flex-col gap-4 rounded-[16px] border border-[#e0e0e0] bg-white p-[13px] shadow-[0px_1px_1px_rgba(0,0,0,0.04),0px_18px_34px_rgba(0,0,0,0.04)] sm:flex-row sm:items-center sm:justify-between sm:gap-6">
    <div className="flex min-w-0 min-h-0 flex-1 items-start gap-3">
      <div className="flex size-10 shrink-0 items-center justify-center rounded-[8px] bg-[#fafafa] text-[var(--foreground)] shadow-[inset_0_0_0_1px_#e0e0e0]">
        <FileArrowDown className="size-5 shrink-0" weight="regular" aria-hidden />
      </div>
      <div className="flex min-w-0 flex-1 flex-col gap-0.5 self-stretch">
        <div className="font-display text-[16px] font-normal leading-5 tracking-[-0.16px] text-[var(--foreground)]">{title}</div>
        {fileLabel ? (
          <div className="text-[12px] leading-4 text-[var(--foreground-muted)]">{fileLabel}</div>
        ) : null}
        {description ? (
          <p className="mt-2 text-[14px] leading-[19.25px] text-[var(--foreground-muted)] [text-wrap:pretty]">{description}</p>
        ) : null}
      </div>
    </div>
    <a
      href={href}
      download
      className="inline-flex w-full shrink-0 items-center justify-center rounded-[8px] bg-[#0a0a0a] px-4 py-2 text-center text-[14px] font-medium leading-5 tracking-[-0.14px] text-[#fafafa] transition-[transform,background-color] duration-200 [transition-timing-function:cubic-bezier(0.2,0,0,1)] hover:bg-[#202020] active:scale-[0.96] focus-visible:ring-2 focus-visible:ring-[var(--ring)] focus-visible:ring-offset-2 focus-visible:outline-none sm:w-auto"
    >
      Download
    </a>
  </div>
)
